'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { GlobeButton } from '@/components/globe/globe-button';
import { ListingDiscoveryActions, type ListingDiscoveryControlsProps } from '@/components/shared/listing-discovery-actions';
import { StartDebateLink } from '@/components/shared/start-debate-link';
import { AnimatedButton } from '@/components/ui/animated-button';
import { HelpCircleIconSolid } from '@/components/ui/icon/glyphs';
import { cn } from '@/lib/ui/utils';
interface WinnersDiscoveryActionsProps extends ListingDiscoveryControlsProps {
  helpOpen: boolean;
  onHelpClick: () => void;
}
export function WinnersDiscoveryActions(t0) {
  const $ = _c(18);
  let controls;
  let helpOpen;
  let onHelpClick;
  if ($[0] !== t0) {
    ({
      helpOpen,
      onHelpClick,
      ...controls
    } = t0);
    $[0] = t0;
    $[1] = controls;
    $[2] = helpOpen;
    $[3] = onHelpClick;
  } else {
    controls = $[1];
    helpOpen = $[2];
    onHelpClick = $[3];
  }
  const t = useTranslations("markets.winners");
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <GlobeButton mode="winner" />;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <StartDebateLink />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("howItWorksAriaLabel");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = helpOpen && "bg-background-tertiary";
  let t5;
  if ($[8] !== t4) {
    t5 = cn("text-foreground-tertiary hover:bg-background-tertiary", t4);
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== helpOpen || $[11] !== onHelpClick || $[12] !== t3 || $[13] !== t5) {
    t6 = <AnimatedButton variant="tertiary" size="default" prefix={HelpCircleIconSolid} onClick={onHelpClick} aria-label={t3} aria-haspopup="dialog" aria-expanded={helpOpen} className={t5} />;
    $[10] = helpOpen;
    $[11] = onHelpClick;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== controls || $[16] !== t6) {
    t7 = <div className="flex shrink-0 items-center gap-0">{t1}<ListingDiscoveryActions {...controls} creationAction={t2}>{t6}</ListingDiscoveryActions></div>;
    $[15] = controls;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}